import styled from '@emotion/styled';

export const RootStyled = styled('div')<{
  isVisible?: boolean;
  width?: string;
}>(({ isVisible, width }) => ({
  width: isVisible ? (width ? width : '35vw') : '0px',
  transition: '0.3s ease',
  opacity: isVisible ? 1 : 0,
  position: 'relative',
  maxWidth: 700,
}));
